// Maps a resolved route to the GA4 page_viewed dimensions. Pathname-prefix
// based (stable across both the _authed and _public route trees, which
// share URL space); page_id comes from the leaf match's params so it is
// the clean route param, not a string-parsed segment.
//
// A route whose URL param is not the entity's id — the member profile is
// addressed by handle — returns `{ pageId }` from its loader, and that
// wins over the param. page_id stays the pseudonymous uuid it has always
// been rather than a name-derived slug, and profile rows stay joinable
// across the handle cutover.

export interface PageIdLoaderData {
  readonly pageId?: string;
}

export type PageType =
  | 'circle'
  | 'network'
  | 'group'
  | 'event'
  | 'resource'
  | 'profile'
  | 'feed'
  | 'people'
  | 'onboarding'
  | 'settings'
  | 'messages'
  | 'other';

const PREFIX_TO_TYPE: ReadonlyArray<[prefix: string, type: PageType]> = [
  ['/circles', 'circle'],
  ['/networks', 'network'],
  ['/groups', 'group'],
  ['/events', 'event'],
  ['/resources', 'resource'],
  ['/members', 'profile'],
  ['/feed', 'feed'],
  ['/people', 'people'],
  ['/onboarding', 'onboarding'],
  ['/settings', 'settings'],
  ['/messages', 'messages'],
];

export function resolvePageMeta(
  pathname: string,
  params: Record<string, string>,
  loaderData?: PageIdLoaderData,
): { page_type: PageType; page_id: string | null } {
  const match = PREFIX_TO_TYPE.find(
    ([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
  if (!match) return { page_type: 'other', page_id: null };
  return { page_type: match[1], page_id: loaderData?.pageId ?? params.id ?? null };
}
